import { __assign } from "tslib";
import * as React from 'react';
/**
 * A loading spinner consisting of two spinning circles.
 */
export var Spinner = function (props) { return (React.createElement("div", __assign({}, props, { className: "app-center" }),
    React.createElement("div", { className: "spinner circles" }, "Loading ..."))); };
//# sourceMappingURL=index.js.map